import { render, staticRenderFns } from "./receivable_statistics_details.vue?vue&type=template&id=0c4a1240&scoped=true&"
import script from "./receivable_statistics_details.vue?vue&type=script&lang=js&"
export * from "./receivable_statistics_details.vue?vue&type=script&lang=js&"
import style0 from "./receivable_statistics_details.vue?vue&type=style&index=0&id=0c4a1240&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a1240",
  null
  
)

export default component.exports